export default {
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login', //login
      component: () => import('./view/login/index.vue'),
      name: 'login',
      props: () => ({ login: true }),
    },
    {
      path: '/reset-password', //resetPassword
      component: () => import('./view/login/resetPassword.vue'),
      name: 'resetPassword',
      props: () => ({ resetPassword: true }),
    },
    {
      path: '/login-internal', //login
      component: () => import('./view/login/index.vue'),
      name: 'loginInternal',
      props: () => ({ loginInternal: true }),
    },
    {
      path: '/internal/announcement', //i02
      component: () => import('./view/detail/index.vue'),
      name: 'announcementIn',
      props: () => ({ announcementIn: true }),
    },
    {
      path: '/external/announcement', //u02
      component: () => import('./view/detail/index.vue'),
      name: 'announcementEx',
      props: () => ({ announcementEx: true }),
    },
    {
      path: '/internal/form/create', //i08
      component: () => import('./view/detail/index.vue'),
      name: 'formCreateIn',
      props: () => ({ formCreateIn: true }),
    },

    {
      path: '/external/form', //u08
      component: () => import('./view/detail/index.vue'),
      name: 'formEx',
      props: () => ({ formEx: true }),
    },
    {
      path: '/internal/form', //i09
      component: () => import('./view/detail/index.vue'),
      name: 'formIn',
      props: () => ({ formIn: true }),
    },
    {
      path: '/external/announcement/create', //u09
      component: () => import('./view/detail/index.vue'),
      name: 'announcementCreateEx',
      props: () => ({ announcementCreateEx: true }),
    },
    {
      path: '/internal/announcement/create', //i10
      component: () => import('./view/detail/index.vue'),
      name: 'announcementCreateIn',
      props: () => ({ announcementCreateIn: true }),
    },
    {
      path: '/internal/announcement/examine-law', //i13
      component: () => import('./view/detail/index.vue'),
      name: 'announcementExamineLawIn',
      props: () => ({ announcementExamineLawIn: true }),
    },
    {
      path: '/internal/announcement/examine-law/:id', //i14
      component: () => import('./view/detail/index.vue'),
      name: 'announcementExamineLawInDesc',
      props: () => ({ announcementExamineLawInDesc: true }),
    },
    {
      path: '/internal/announcement/assign-task', //i11
      component: () => import('./view/detail/index.vue'),
      name: 'announcementAssignTaskIn',
      props: () => ({ announcementAssignTaskIn: true }),
    },
    {
      path: '/internal/announcement/assign-task/batch',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementBatchAssignTaskIn',
      props: () => ({ announcementBatchAssignTaskIn: true }),
    },
    {
      path: '/internal/announcement/return/batch',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementBatchReturnReviewIn',
      props: () => ({ announcementBatchReturnReviewIn: true }),
    },
    {
      path: '/internal/announcement/discard/batch',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementBatchDiscardReviewIn',
      props: () => ({ announcementBatchDiscardReviewIn: true }),
    },
    {
      path: '/internal/announcement/cancel/batch',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementBatchCancelReviewIn',
      props: () => ({ announcementBatchCancelReviewIn: true }),
    },
    {
      path: '/internal/announcement/proof-reading', //i17
      component: () => import('./view/detail/index.vue'),
      name: 'announcementProofReadingIn',
      props: () => ({ announcementProofReadingIn: true }),
    },
    {
      path: '/internal/announcement/proof-reading/:id', //i18
      component: () => import('./view/detail/index.vue'),
      name: 'announcementProofReadingDetailIn',
      props: () => ({ announcementProofReadingDetailIn: true }),
    },
    {
      path: '/internal/announcement/formatting-document', //i19
      component: () => import('./view/detail/index.vue'),
      name: 'announcementFormattingDocumentIn',
      props: () => ({ announcementFormattingDocumentIn: true }),
    },
    {
      path: '/internal/announcement/formatting-document/:id', // i21
      component: () => import('./view/detail/index.vue'),
      name: 'announcementFormattingDocumentList',
      props: () => ({ announcementFormattingDocumentList: true }),
    },
    {
      path: '/internal/announcement/formatting-document/history', // i42
      component: () => import('./view/detail/index.vue'),
      name: 'announcementFormattingDocumentHistory',
      props: () => ({ announcementFormattingDocumentHistory: true }),
    },
    {
      path: '/internal/announcement/waiting-list', //i07
      component: () => import('./view/detail/index.vue'),
      name: 'announcementWaitingListIn',
      props: () => ({ announcementWaitingListIn: true }),
    },
    {
      path: '/internal/announcement/waiting-list/:id', //i07-1
      component: () => import('./view/detail/index.vue'),
      name: 'announcementWaitingListInDesc',
      props: () => ({ announcementWaitingListInDesc: true }),
    },
    {
      path: '/internal/announcement/waiting-list-format', //i15
      component: () => import('./view/detail/index.vue'),
      name: 'announcementWaitingListFormat',
      props: () => ({ announcementWaitingListFormat: true }),
    },
    {
      path: '/internal/announcement/waiting-list-format/:id', //i16
      component: () => import('./view/detail/index.vue'),
      name: 'announcementWaitingListFormatDetail',
      props: () => ({ announcementWaitingListFormatDetail: true }),
    },
    {
      path: '/internal/dashboard', //i40
      component: () => import('./view/detail/index.vue'),
      name: 'dashboardIn',
      props: () => ({ dashboardIn: true }),
    },
    {
      // I44
      path: '/internal/draft-announcement-admission',
      component: () => import('./view/detail/index.vue'),
      name: 'draftAnnouncementAdmissionIn',
      props: () => ({ draftAnnouncementAdmissionIn: true }),
    },
    {
      // I45
      path: '/internal/draft-announcement-admission/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'draftAnnouncementAdmissionDetailIn',
      props: () => ({ draftAnnouncementAdmissionDetailIn: true }),
    },
    {
      // I39
      path: '/internal/report/process/history',
      component: () => import('./view/detail/index.vue'),
      name: 'reportProcessHistoryIn',
      props: () => ({ reportProcessHistoryIn: true }),
    },
    {
      // I43
      path: '/internal/report/publisher/history',
      component: () => import('./view/detail/index.vue'),
      name: 'reportPublisherHistoryIn',
      props: () => ({ reportPublisherHistoryIn: true }),
    },
    {
      // RKJ-PUB-PAGE-01
      path: '/internal/announcement/publisher-volumes',
      component: () => import('./view/detail/index.vue'),
      name: 'publisherVolumeListIn',
      props: () => ({ publisherVolumeListIn: true }),
    },
    {
      // RKJ-PUB-PAGE-02
      path: '/internal/announcement/publisher-volumes/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'publisherVolumeDetailIn',
      props: () => ({ publisherVolumeDetailIn: true }),
    },
    {
      // RKJ-PUB-PAGE-03
      path: '/internal/announcement/publisher/documents/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'publisherDocumentDetailIn',
      props: () => ({ publisherDocumentDetailIn: true }),
    },
    {
      path: '/internal/department', //i27
      component: () => import('./view/detail/index.vue'),
      name: 'departmentIn',
      props: () => ({ departmentIn: true }),
    },
    {
      path: '/internal/group', //i31
      component: () => import('./view/detail/index.vue'),
      name: 'groupIn',
      props: () => ({ groupIn: true }),
    },
    {
      path: '/internal/user', //i35
      component: () => import('./view/detail/index.vue'),
      name: 'userIn',
      props: () => ({ userIn: true }),
    },
    {
      path: '/internal/department/:id', //i29
      component: () => import('./view/detail/index.vue'),
      name: 'editDepartmentIn',
      props: () => ({ editDepartmentIn: true }),
    },
    {
      path: '/internal/group/:id', //i33
      component: () => import('./view/detail/index.vue'),
      name: 'editGroupIn',
      props: () => ({ editGroupIn: true }),
    },
    {
      path: '/internal/user/:id', //i37
      component: () => import('./view/detail/index.vue'),
      name: 'editUserIn',
      props: () => ({ editUserIn: true }),
    },
    {
      path: '/internal/department/create', //i28
      component: () => import('./view/detail/index.vue'),
      name: 'createDepartmentIn',
      props: () => ({ createDepartmentIn: true }),
    },
    {
      path: '/internal/group/create', //i32
      component: () => import('./view/detail/index.vue'),
      name: 'createGroupIn',
      props: () => ({ createGroupIn: true }),
    },
    {
      path: '/internal/user/create', //i36
      component: () => import('./view/detail/index.vue'),
      name: 'createUserIn',
      props: () => ({ createUserIn: true }),
    },
    {
      path: '/internal/roles',
      component: () => import('./view/detail/index.vue'),
      name: 'rolesIn',
      props: () => ({ rolesIn: true }),
    },
    {
      path: '/internal/roles/create',
      component: () => import('./view/detail/index.vue'),
      name: 'createRolesIn',
      props: () => ({ createRolesIn: true }),
    },
    {
      path: '/internal/roles/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'editRolesIn',
      props: () => ({ editRolesIn: true }),
    },
    {
      // i20
      path: '/internal/announcement/formatting-document/volume',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementFormattingDocumentVolume',
      props: () => ({ announcementFormattingDocumentVolume: true }),
    },
    {
      path: '/external/user/:id', //u12
      component: () => import('./view/detail/index.vue'),
      name: 'editUserEx',
      props: () => ({ editUserEx: true }),
    },
    {
      path: '/external/user/create', //u11
      component: () => import('./view/detail/index.vue'),
      name: 'createUserEx',
      props: () => ({ createUserEx: true }),
    },
    {
      path: '/external/user', //u10
      component: () => import('./view/detail/index.vue'),
      name: 'userEx',
      props: () => ({ userEx: true }),
    },
    {
      // I26
      path: '/internal/announcement/publisher',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementPublisherIn',
      props: () => ({ announcementPublisherIn: true }),
    },
    {
      path: '/internal/announcement/publisher/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementPublisherListIn',
      props: () => ({ announcementPublisherListIn: true }),
    },
    {
      path: '/external/draft-announcement',
      component: () => import('./view/detail/index.vue'),
      name: 'draftAnnouncementEx',
      props: () => ({ draftAnnouncementEx: true }),
    },
    {
      path: '/internal/draft-announcement',
      component: () => import('./view/detail/index.vue'),
      name: 'draftAnnouncementIn',
      props: () => ({ draftAnnouncementIn: true }),
    },
    {
      // I22
      path: '/internal/announcement/publish',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementPublishIn',
      props: () => ({ announcementPublishIn: true }),
    },
    {
      // I24
      path: '/internal/announcement/publish/suspend/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementPublishSuspendListIn',
      props: () => ({ announcementPublishSuspendListIn: true }),
    },
    {
      // I25
      path: '/internal/announcement/publish/cancel/suspend/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementPublishCancelSuspendListIn',
      props: () => ({ announcementPublishCancelSuspendListIn: true }),
    },
    {
      // I17-1
      path: '/internal/announcement/proof-reading/list/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementProofReadingListIn',
      props: () => ({ announcementProofReadingListIn: true }),
    },
    {
      path: '/internal/draft-announcement/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'draftAnnouncementDetailIn',
      props: () => ({ draftAnnouncementDetailIn: true }),
    },
    {
      path: '/external/draft-announcement/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'draftAnnouncementDetailEx',
      props: () => ({ draftAnnouncementDetailEx: true }),
    },
    {
      path: '/internal/announcement/assign-task/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementAssignTaskDescIn',
      props: () => ({ announcementAssignTaskDescIn: true }),
    },
    {
      path: '/internal/announcement/publish/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementPublishListIn',
      props: () => ({ announcementPublishListIn: true }),
    },
    {
      path: '/internal/announcement/return/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementReturnDetailIn',
      props: () => ({ announcementReturnDetailIn: true }),
    },
    {
      path: '/external/announcement/return/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementReturnDetailEx',
      props: () => ({ announcementReturnDetailEx: true }),
    },
    {
      path: '/internal/announcement/discard/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementDiscardDetailIn',
      props: () => ({ announcementDiscardDetailIn: true }),
    },
    {
      path: '/internal/announcement/cancel/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementCancelDetailIn',
      props: () => ({ announcementCancelDetailIn: true }),
    },
    {
      path: '/internal/ministry',
      component: () => import('./view/detail/index.vue'),
      name: 'ministryIn',
      props: () => ({ ministryIn: true }),
    },
    {
      path: '/internal/agency',
      component: () => import('./view/detail/index.vue'),
      name: 'agencyIn',
      props: () => ({ agencyIn: true }),
    },
    {
      path: '/internal/ministry/external-user',
      component: () => import('./view/detail/index.vue'),
      name: 'externalUserIn',
      props: () => ({ externalUserIn: true }),
    },
    {
      path: '/internal/ministry/external-user/create',
      component: () => import('./view/detail/index.vue'),
      name: 'createExternalUserIn',
      props: () => ({ createExternalUserIn: true }),
    },
    {
      path: '/internal/ministry/external-user/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'editExternalUserIn',
      props: () => ({ editExternalUserIn: true }),
    },
    {
      path: '/internal/ministry/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'editMinistryIn',
      props: () => ({ editMinistryIn: true }),
    },
    {
      path: '/internal/ministry/create',
      component: () => import('./view/detail/index.vue'),
      name: 'createMinistryIn',
      props: () => ({ createMinistryIn: true }),
    },
    {
      path: '/internal/agency/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'editAgencyIn',
      props: () => ({ editAgencyIn: true }),
    },
    {
      path: '/internal/agency/create',
      component: () => import('./view/detail/index.vue'),
      name: 'createAgencyIn',
      props: () => ({ createAgencyIn: true }),
    },
    {
      path: '/internal/agency/report/announcement',
      component: () => import('./view/detail/index.vue'),
      name: 'reportAnnouncement',
      props: () => ({ reportAnnouncement: true }),
    },
    {
      path: '/internal/agency/report/announcement-history',
      component: () => import('./view/detail/index.vue'),
      name: 'reportAnnouncementHistory',
      props: () => ({ reportAnnouncementHistory: true }),
    },
    {
      path: '/internal/agency/report/announcement-statistics',
      component: () => import('./view/detail/index.vue'),
      name: 'reportAnnouncementStatistics',
      props: () => ({ reportAnnouncementStatistics: true }),
    },
    {
      path: '/internal/agency/report/migrate-data',
      component: () => import('./view/detail/index.vue'),
      name: 'reportMigrate',
      props: () => ({ reportMigrate: true }),
    },
    {
      path: '/internal/announcement/publish/special',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementPublishSpecialDetailIn',
      props: () => ({ announcementPublishSpecialDetailIn: true }),
    },
    {
      path: '/internal/agency/report/daily',
      component: () => import('./view/detail/index.vue'),
      name: 'reportDaily',
      props: () => ({ reportDaily: true }),
    },
    {
      path: '/internal/agency/report/performance',
      component: () => import('./view/detail/index.vue'),
      name: 'reportPerformance',
      props: () => ({ reportPerformance: true }),
    },
    {
      path: '/internal/agency/report/quantity-year',
      component: () => import('./view/detail/index.vue'),
      name: 'reportQuantityYear',
      props: () => ({ reportQuantityYear: true }),
    },
    {
      path: '/internal/agency/report/quantity-monthly',
      component: () => import('./view/detail/index.vue'),
      name: 'reportQuantityMonthly',
      props: () => ({ reportQuantityMonthly: true }),
    },
    {
      path: '/internal/holiday',
      component: () => import('./view/detail/index.vue'),
      name: 'holiday',
      props: () => ({ holiday: true }),
    },
    {
      path: '/internal/activity-log',
      component: () => import('./view/detail/index.vue'),
      name: 'activityLogIn',
      props: () => ({ activityLogIn: true }),
    },
    {
      path: '/external/announcement/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementDetailEx',
      props: () => ({ announcementDetailEx: true }),
    },
    {
      path: '/internal/announcement/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementDetailIn',
      props: () => ({ announcementDetailIn: true }),
    },
    {
      path: '/internal/announcement/formatting-document/volume/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementFormattingDocumentVolumeDetailIn',
      props: () => ({ announcementFormattingDocumentVolumeDetailIn: true }),
    },
    {
      path: '/internal/announcement/formatting-document/list/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementFormattingDocumentListDetailIn',
      props: () => ({ announcementFormattingDocumentListDetailIn: true }),
    },
    {
      path: '/internal/announcement/publish/list/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementPublishListDetailIn',
      props: () => ({ announcementPublishListDetailIn: true }),
    },
    {
      path: '/internal/announcement/publisher/list/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementPublisherListDetailIn',
      props: () => ({ announcementPublisherListDetailIn: true }),
    },
    {
      path: '/internal/announcement/publish/suspend/list/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementPublishSuspendListDetailIn',
      props: () => ({ announcementPublishSuspendListDetailIn: true }),
    },
    {
      path: '/internal/announcement/publish/cancel/suspend/list/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementPublishCancelSuspendListDetailIn',
      props: () => ({ announcementPublishCancelSuspendListDetailIn: true }),
    },
    {
      path: '/external/agency/report/announcement',
      component: () => import('./view/detail/index.vue'),
      name: 'reportAnnouncementEx',
      props: () => ({ reportAnnouncementEx: true }),
    },
    {
      path: '/internal/heirachy',
      component: () => import('./view/detail/index.vue'),
      name: 'heirachyIn',
      props: () => ({ heirachyIn: true }),
    },
    {
      path: '/internal/heirachy/create',
      component: () => import('./view/detail/index.vue'),
      name: 'heirachyCreateIn',
      props: () => ({ heirachyCreateIn: true }),
    },
    {
      path: '/internal/heirachy/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'heirachyDetailIn',
      props: () => ({ heirachyDetailIn: true }),
    },
    {
      path: '/internal/heirachy-type',
      component: () => import('./view/detail/index.vue'),
      name: 'heirachyTypeIn',
      props: () => ({ heirachyTypeIn: true }),
    },
    {
      path: '/internal/heirachy-type/create',
      component: () => import('./view/detail/index.vue'),
      name: 'heirachyTypeCreateIn',
      props: () => ({ heirachyTypeCreateIn: true }),
    },
    {
      path: '/internal/heirachy-type/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'heirachyTypeDetailIn',
      props: () => ({ heirachyTypeDetailIn: true }),
    },
    {
      path: '/internal/announcement-type',
      component: () => import('./view/detail/index.vue'),
      name: 'announcementTypeIn',
      props: () => ({ announcementTypeIn: true }),
    },
    {
      path: '/internal/announcement-type/create',
      component: () => import('./view/detail/index.vue'),
      name: 'createAnnouncementTypeIn',
      props: () => ({ createAnnouncementTypeIn: true }),
    },
    {
      path: '/internal/announcement-type/:id',
      component: () => import('./view/detail/index.vue'),
      name: 'editAnnouncementTypeIn',
      props: () => ({ editAnnouncementTypeIn: true }),
    },
  ],
}
